import { CLIENT_AREA_PERMISSIONS } from '@constants/client-area-permissions.constant';
import { EUserProfileIds, type IUser } from '@interfaces/user';

export function getProfilePermissions(user?: IUser | null): string[] {
	return user?.profilePermissions ?? [];
}

export function hasProfilePermission(
	user: IUser | null | undefined,
	key: string
): boolean {
	return getProfilePermissions(user).includes(key);
}

export function isApplicationAdmin(user?: IUser | null): boolean {
	return user?.profileId === EUserProfileIds.APPLICATION_ADMIN;
}

export function hasAssociatedUserProfile(user?: IUser | null): boolean {
	return Boolean(user?.userProfileId);
}

function isLegacyApplicationAdmin(user?: IUser | null): boolean {
	return isApplicationAdmin(user) && !hasAssociatedUserProfile(user);
}

export function canAccessClientArea(user?: IUser | null): boolean {
	if (isLegacyApplicationAdmin(user)) return true;
	return hasProfilePermission(user, CLIENT_AREA_PERMISSIONS.access);
}

export function canManageClientAreaDocuments(user?: IUser | null): boolean {
	if (isLegacyApplicationAdmin(user)) return true;
	return hasProfilePermission(user, CLIENT_AREA_PERMISSIONS.manageDocuments);
}

export function canManageClientAreaCategories(user?: IUser | null): boolean {
	if (isLegacyApplicationAdmin(user)) return true;
	return hasProfilePermission(user, CLIENT_AREA_PERMISSIONS.manageCategories);
}
